import { createMagicDoorContext } from '~/contexts/utils';
import { IRSRepository } from '~/repositories/irsRepository';
import type { SubmitIrisCorrectionDto, SubmitIrisTransmissionDto } from '~/swagger/portal/Api';
export const [IrsProvider, useIrs] = createMagicDoorContext('Irs', () => {
  const repo = new IRSRepository();
  const submitIrisTransmission = async (payload: SubmitIrisTransmissionDto) => {
    const response = await repo.submitIrisTransmission(payload);
    return response;
  };

  const submitIrisCorrection = async (payload: SubmitIrisCorrectionDto) => {
    const response = await repo.submitIrisCorrection(payload);
    return response;
  };

  return {
    submitIrisTransmission,
    submitIrisCorrection,
  };
});
